module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-4-60049a6035f40b196efb2d7d61cdd241.png";